import {
  AccessFunctionFormData,
  AccessFunctionInterfaceFormSectionType,
} from 'data/accessFunction/accessFunction.types';
import { FormTemplate } from 'data/template/template.types';

// this function will update encription field based on secinfoid
export default function handleEncriptionViaFieldUpdate(
  template: FormTemplate | undefined,
  interfaceName: AccessFunctionInterfaceFormSectionType,
  clonedData: Partial<AccessFunctionFormData>,
  fieldName: string,
  fieldValue: unknown,
  fieldsResponsableForChange: string[],
): Partial<AccessFunctionFormData> {

  // This function is only for field secinfoid
  if (
    template == null ||
    !fieldsResponsableForChange.includes(fieldName) ||
    (interfaceName !== 'provisioningInterfaces' && interfaceName !== 'dataInterfaces') ||
    (clonedData.type !== 'ACME_X123' && clonedData.tag !== 'SONUS_SBC')
  ) {
    return clonedData;
  }

  clonedData[interfaceName] = clonedData[interfaceName]?.map((interfaceEntry) => {

    if (fieldValue === 'Tk9ORQ') {
      return {
        ...interfaceEntry,
        encryption: 'DISABLED',
      };
    }

    return {
      ...interfaceEntry,
      encryption: 'ENABLED',
    };
  });

  return clonedData;
}
